import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import Button from './Button';
import ModalHeader from './ModalHeader';
import i18n from '../../src/i18n/translate';

const RULE_SET_BUTTONS = Object.freeze([
  {
    ruleSet: 'he_admin',
    label: i18n.t('Higher Education Students')
  },
  {
    ruleSet: 'fac_staff_admin',
    label: i18n.t('Faculty & Staff')
  },
  {
    ruleSet: 'cc_admin',
    label: i18n.t('Employees')
  },
  {
    ruleSet: 'scorm_manager',
    label: i18n.t('Scorm')
  }
]);

const RuleSetModal = ({ href, onCancel, ruleSets = [], show }) => {

  const [ruleSet, setRuleSet] = useState();
  const isCancelable = !!onCancel;
  const ruleSetButtons = RULE_SET_BUTTONS.filter(ruleSetButton => ruleSets.includes(ruleSetButton.ruleSet));

  if (ruleSetButtons.length < 2) {
    return null;
  }

  const handleOnCancel = () => {
    setRuleSet();
    onCancel();
  };

  return (
    <Modal
      id="rule-set-modal"
      className="rule-set-modal modal-size-small"
      dialogClassName="foundry"
      show={show}
      aria-labelledby="rule-set-modal-title"
    >
      <ModalHeader
        canClickOff={isCancelable}
        className="rule-set-modal-title"
        closeButton={false}
        description={i18n.t('Select the population you are here to train or the admin settings you would like to manage.')}
        onCancel={handleOnCancel}
        title={i18n.t('Select a Population')}
        titleId="rule-set-modal-title"
      />
      <Modal.Body>
        {ruleSetButtons.map(({ ruleSet: rs, label }) => (
          <Button
            key={rs}
            block={true}
            data-object-type="reports"
            data-action="select-population"
            data-object-id={rs}
            className={`large${rs === ruleSet ? ' selected' : ''}`}
            label={label}
            onClick={() => setRuleSet(rs)}
            style="pill"
          />
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button
          block={true}
          className="large"
          disabled={!ruleSet}
          href={`${href}?current_rule_set_name=${ruleSet}`}
          data-object-type="reports-navigation"
          data-action="select-population-next"
          label={i18n.t('Next')}
          style="primary"
        />
        {isCancelable && (
          <Button
            block={true}
            label={i18n.t('Cancel')}
            data-object-type="reports-navigation"
            data-action="select-population-cancel"
            onClick={handleOnCancel}
            style="link"
          />
        )}
      </Modal.Footer>
    </Modal>
  );
}

RuleSetModal.propTypes = {
  href: PropTypes.string,
  onCancel: PropTypes.func,
  ruleSets: PropTypes.array,
  show: PropTypes.bool
};

export default RuleSetModal;
